import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { EnterpriseService } from "../enterprise.service";

@Component({
  selector: "app-enterprise-dashboard",
  templateUrl: "./enterprise-dashboard.component.html",
  styleUrls: ["./enterprise-dashboard.component.sass"],
})
export class EnterpriseDashboardComponent implements OnInit {

  id!: string;
  ENTPDetails: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private enterpriseService: EnterpriseService,
    private spinner: NgxSpinnerService,
    private toast: ToastrService
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      this.id = params['id'];
      console.log("Enterprise ID from URL:", this.id);

      if (this.id) {
        this.getDetailsById();
      } else {
        this.toast.error("ID missing");
      }
    });
  }

  getDetailsById() {
    this.spinner.show();

    this.enterpriseService.getEnterprisedetails(this.id).subscribe(
      (result: any) => {
        this.spinner.hide();

        if (result.statusCode === 200) {
          this.ENTPDetails = result.data;
          console.log("Enterprise details:", this.ENTPDetails);
        } else {
          this.toast.error(result.message);
        }
      },
      () => {
        this.spinner.hide();
        this.toast.error("Server error");
      }
    );
  }
}
